import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag.ts';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest.ts';

type GetCompositionCdnOptions = {
	isPreview?: boolean;
};

export const getCompositionCdn = ({ isPreview = false }: GetCompositionCdnOptions = {}) => {
	const useWacman = checkFeatureFlagGate(featureFlags.useWacman);

	if (isPreview) {
		return useWacman
			? process.env['WAC_MANAGEMENT_PREVIEW_CDN']
			: process.env['UNIFORM_PREVIEW_CDN'];
	}

	return useWacman ? process.env['WAC_MANAGEMENT_CDN'] : process.env['UNIFORM_CDN'];
};
